export default {
   getClass: (state) => (className) => {
      // return true;
      return state[className];
   },

}